import { render, staticRenderFns } from "./vitalConfig.vue?vue&type=template&id=def15674&scoped=true&"
import script from "./vitalConfig.vue?vue&type=script&lang=js&"
export * from "./vitalConfig.vue?vue&type=script&lang=js&"
import style0 from "./vitalConfig.vue?vue&type=style&index=0&id=def15674&scoped=true&lang=css&"
import style1 from "./vitalConfig.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def15674",
  null
  
)

export default component.exports